import { auth } from '@/firebase';

const URL = 'https://us-central1-mesh-db-stg.cloudfunctions.net/alerts';

class Alerts {
    static async get(path='', token=null) {
        // Handle regular REST API requests
        const response = await fetch(`${URL}${path}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
                'Content-Type': 'application/json',
            },
        });

        return response.json();
    }

    static async post(body, token=null) {
        const response = await fetch(`${URL}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });

        return response.json();
    }

    static async put(body, token=null) {
        const response = await fetch(`${URL}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return response.json();
    }

    static async delete(body, token=null) {
        const response = await fetch(`${URL}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return response.json();
    }
}

export default Alerts;